import createIcon from '../../createIcon';

/**
 * @component @name SettingsSystemDaydream
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxNkgxNS41QzE2Ljg4IDE2IDE4IDE0Ljg4IDE4IDEzLjVDMTggMTIuMTIgMTYuODggMTEgMTUuNSAxMUgxNS40NUMxNS4yMSA5LjMxIDEzLjc2IDggMTIgOEMxMC42IDggOS40IDguODMgOC44NCAxMC4wMkg4LjY4QzcuMTcgMTAuMTggNiAxMS40NSA2IDEzQzYgMTQuNjYgNy4zNCAxNiA5IDE2Wk0yMSAzSDNDMS45IDMgMSAzLjkgMSA1VjE5QzEgMjAuMSAxLjkgMjEgMyAyMUgyMUMyMi4xIDIxIDIzIDIwLjEgMjMgMTlWNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTIxIDE5LjAxSDNWNC45OUgyMVYxOS4wMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsSystemDaydream = createIcon('SettingsSystemDaydream', [
  [
    'path',
    {
      d: 'M9 16H15.5C16.88 16 18 14.88 18 13.5C18 12.12 16.88 11 15.5 11H15.45C15.21 9.31 13.76 8 12 8C10.6 8 9.4 8.83 8.84 10.02H8.68C7.17 10.18 6 11.45 6 13C6 14.66 7.34 16 9 16ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01Z',
      key: '3ae3wp',
    },
  ],
]);

export default SettingsSystemDaydream;
